export const PULSELEADS_CAMPAIGN_FEEDBACK_TITLE = "title.pulseleads.campaignFeedback";

export const PULSELEADS_CAMPAIGN_FEEDBACK_NAMESPACE = "PULSELEADS-CAMPAIGN-FEEDBACK";

export const PULSELEADS_CAMPAIGN_FEEDBACK_PATH = "/campaign-feedback";